import { useState, useEffect } from "react";
import { domain } from "config.js";
import style from "./style.module.scss";

import ResultItem from "../../SearchResult/Item/Item";

const chosen = ["Man-1", "Teu-7", "Ben-17", "Tor-47", "Est-61", "Alt-1"];

function SampleProperties() {
    const [properties, setProperties] = useState(chosen.map(ch => ({})));
    const [ImageCache, setImageCache] = useState({ result: {} });

    //get chosen properties
    useEffect(() => {
        chosen.forEach(ref => {
            fetch(domain + "/int-search", { method: "POST", body: JSON.stringify({ ref: ref }) }).then(response => {
                response.json().then(json => {
                    setProperties(oldProperties => {
                        const newProps = [...oldProperties];

                        let empty = 0;
                        for (let i = 0; i < newProps.length; i++) {
                            if (Object.keys(newProps[i]).length === 0) {
                                empty = i;
                                break;
                            }
                        }

                        newProps[empty] = json[0];
                        return newProps;
                    })
                });
            }).catch(err => { console.log(err) });
        });
    }, []);

    return <div className={style.SampleProperties + " row"}>
        <div className={style.title + " title-font"}>EEN GREEP UIT ONS AANBOD VAN MEER DAN 600 EIGENDOMMEN</div>
        <div className={style.properties}>
            {properties.map(property => <ResultItem key={Object.keys(property)[0]} refno={Object.keys(property)[0]} data={Object.values(property)[0]} ImageCache={{ images: ImageCache, setImages: setImageCache }} />)}
        </div>
    </div>
}

export default SampleProperties;